import React from 'react';
import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { IDeliveryZone } from "@app/common";

interface DeliveryZoneDeleteModalProps extends ModalInstance<IDeliveryZone>, Omit<DeleteModalProps<IDeliveryZone>, 'children'> {
  onDelete: (deliveryZone: Partial<IDeliveryZone>) => void;
}

export const DeliveryZoneDeleteModal = (props: DeliveryZoneDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer une zone de livraison.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}

